export enum PermissionNameEnum {
  dashboard = 'dashboard',
  atpPolicy = 'atpPolicy',
  dlpPolicy = 'dlpPolicy',
  log = 'log',
  report = 'report',
  quarantine = 'quarantine',
  administrator = 'administrator',
}

export enum PermissionAction {
  ViewOnly = 'read',
  Editable = 'write',
  NoAccess = 'none',
}

export enum RolePermissionEnum {
  dashboard = 'dashboard',
  atpPolicy = 'atpPolicy',
  dlpPolicy = 'dlpPolicy',
  logReport = 'logReport',
  quarantine = 'quarantine',
}

export interface Permission {
  dashboard: PermissionAction[];
  atpPolicy: PermissionAction[];
  dlpPolicy: PermissionAction[];
  log: PermissionAction[];
  report: PermissionAction[];
  quarantine: PermissionAction[];
  administrator: PermissionAction[];
}
